module.exports = __webpack_public_path__ + "img/hearts.183b2a6.png";